/* Configurador Dolphin: bloque de tema para Horizon.
   Pinta la camiseta por zonas y envía el diseño con el formulario del producto
   como propiedades de línea (line item properties). Requiere configurador-dolphin-data.js. */
(() => {
  if (customElements.get('dolphin-configurador')) return;

  const NS_SVG = 'http://www.w3.org/2000/svg';
  const NS_XLINK = 'http://www.w3.org/1999/xlink';
  const MAX_BYTES = 5 * 1024 * 1024;
  const redondear = n => Math.round(n * 100) / 100;
  const medidas = (ratio, lado) => (ratio >= 1 ? { w: lado, h: lado / ratio } : { w: lado * ratio, h: lado });

  class DolphinConfigurador extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      const D = window.DolphinConfiguradorData;
      const raiz = this.querySelector('[data-cd-root]');
      if (!D || !raiz) return;
      this._listo = true;
      iniciar(this, raiz, D);
    }
  }

  function iniciar(host, raiz, D) {
    const r = n => raiz.querySelector(`[data-r="${n}"]`);
    const svg = r('svg');
    const filas = r('filas');
    const estado = r('estado');
    const contModelos = r('modelos');
    const combos = r('combos');
    const escudoOn = raiz.dataset.escudo === 'true' && !!r('btn-escudo');
    const sponsorsOn = raiz.dataset.sponsors === 'true' && !!r('btn-sponsor');
    const MAX_SPONSORS = Math.min(3, Math.max(1, parseInt(raiz.dataset.maxSponsors, 10) || 3));
    const PALETA = D.paleta;
    const MODELOS = D.modelos;

    let modelo = MODELOS[0];
    let GRUPOS = modelo.grupos;
    let INICIAL = modelo.inicial;
    let paleta = PALETA;
    let colores = { ...INICIAL };
    let coloresE = {};          // colores propios de la espalda (solo los que se cambiaron; el resto sigue al frente)
    const colorEsp = g => coloresE[g] || colores[g];
    const colorDe = g => (vista === 'espalda' ? colorEsp(g) : colores[g]);
    let activo = null;
    let personalizado = false; // pasa a true cuando el cliente toca algo

    function decir(msg) { estado.textContent = msg; }

    /* ---------- campos del formulario del producto ---------- */
    const contCampos = r('campos');
    const formId = raiz.dataset.formId;
    const campos = {};
    function campo(nombre, tipo) {
      const i = document.createElement('input');
      i.type = tipo; i.name = `properties[${nombre}]`; i.disabled = true;
      i.setAttribute('data-cd-campo', nombre);
      contCampos.appendChild(i);
      campos[nombre] = i;
      return i;
    }
    campo('Modelo', 'hidden');
    campo('Diseño', 'hidden');
    campo('_diseno', 'hidden');
    campo('Vista previa', 'file');
    campo('Vista previa espalda', 'file');
    if (escudoOn) campo('Escudo', 'file');
    if (sponsorsOn) for (let n = 1; n <= MAX_SPONSORS; n++) campo(`Sponsor ${n}`, 'file');

    // El formulario de Horizon se llama BuyButtons-ProductForm-<id de sección>; si no coincide se busca
    function vincular() {
      let id = formId;
      if (!id || !document.getElementById(id)) {
        const f = document.querySelector('form[id^="BuyButtons-ProductForm"]') ||
                  document.querySelector('form[action*="/cart/add"]');
        if (f) { if (!f.id) f.id = 'cd-form-producto'; id = f.id; }
      }
      if (!id) return;
      Object.values(campos).forEach(c => c.setAttribute('form', id));
      const f = document.getElementById(id);
      if (f) f.setAttribute('enctype', 'multipart/form-data'); // por si el envío no es por AJAX
    }
    vincular();

    function ponerArchivo(nombre, file) {
      const c = campos[nombre];
      if (!c) return;
      try {
        const dt = new DataTransfer();
        if (file) dt.items.add(file);
        c.files = dt.files;
      } catch (e) { /* navegador sin DataTransfer: el archivo no viaja, el JSON sí */ }
      c.dataset.tiene = file ? '1' : '';
    }

    function datosTexto(c) {
      const T = txt[c];
      if (!T.texto) return null;
      return { texto: T.texto, x: redondear(T.cx), y: redondear(T.cy), tam: redondear(T.tam), giro: redondear(T.giro), arco: c === 'nombre' ? redondear(T.arco) : 0, color: colorTextoEfectivo(c), fuente: fuenteDe(T.fuente).id };
    }

    function actualizarCampos() {
      const hab = personalizado;
      campos['Modelo'].value = modelo.nombre;
      campos['Modelo'].disabled = !hab;
      const partes = GRUPOS.map(([id, nom]) => `${nom}: ${colores[id].toUpperCase()}`);
      const extras = [`Logo Dolphin: ${NOMBRE_POS[marcaPos]}`];
      if (escudoOn && escudo.hay()) extras.push('Escudo: sí');
      if (sponsorsOn && sponsors.length) extras.push(`Sponsors: ${sponsors.length}`);
      const resumen = arr => {
        const cuenta = {};
        arr.forEach(f => { const c = `${f.tipo}|${f.parte}`; cuenta[c] = (cuenta[c] || 0) + 1; });
        return Object.entries(cuenta).map(([c, n]) => {
          const [t, pa] = c.split('|');
          return `${defForma(t).nombre}${n > 1 ? ` x${n}` : ''}${pa !== 'delantero' ? ` (${PARTES[pa].corto})` : ''}`;
        }).join(', ');
      };
      let txtEsp = `Espalda: ${NOMBRE_ESP[espModo]}${espModo === 'lisa' ? ' ' + colorEspalda().toUpperCase() : ''}`;
      if (formasE.length) txtEsp += `, formas: ${resumen(formasE)}`;
      const propios = GRUPOS.filter(([id]) => coloresE[id]);
      if (propios.length) txtEsp += `, colores propios: ${propios.map(([id, nom]) => `${nom} ${coloresE[id].toUpperCase()}`).join(', ')}`;
      if (txt.nombre.texto) txtEsp += `, nombre: ${txt.nombre.texto} (${fuenteDe(txt.nombre.fuente).nombre})`;
      if (txt.numero.texto) txtEsp += `, número: ${txt.numero.texto} (${fuenteDe(txt.numero.fuente).nombre})`;
      extras.push(txtEsp);
      if (formas.length) extras.push('Formas: ' + resumen(formas));
      campos['Diseño'].value = partes.concat(extras).join(' | ');
      campos['Diseño'].disabled = !hab;
      const json = {
        modelo: modelo.id, colores,
        escudo: escudoOn ? escudo.pos() : null,
        sponsors: sponsorsOn ? sponsors.filter(s => s.logo.hay()).map(s => ({ slot: s.slot, ...s.logo.pos() })) : [],
        marca: { posicion: marcaPos, ...marcaGeom(marcaPos), tono: marcaTono },
        formas: formas.map(f => ({ tipo: f.tipo, parte: f.parte, x: redondear(f.cx), y: redondear(f.cy), tam: redondear(f.tam), ancho: redondear(f.prop), giro: redondear(f.giro), color: f.color })),
        espalda: {
          modo: espModo, color: espModo === 'lisa' ? colorEspalda() : null,
          colores: Object.fromEntries(GRUPOS.map(([id]) => [id, colorEsp(id)])),
          coloresPropios: { ...coloresE },
          formas: formasE.map(f => ({ tipo: f.tipo, parte: f.parte, x: redondear(f.cx), y: redondear(f.cy), tam: redondear(f.tam), ancho: redondear(f.prop), giro: redondear(f.giro), color: f.color })),
          nombre: datosTexto('nombre'), numero: datosTexto('numero')
        },
        lienzo: 500
      };
      campos['_diseno'].value = JSON.stringify(json);
      campos['_diseno'].disabled = !hab;
      campos['Vista previa'].disabled = !hab || !campos['Vista previa'].dataset.tiene;
      campos['Vista previa espalda'].disabled = !hab || !campos['Vista previa espalda'].dataset.tiene;
      if (escudoOn) campos['Escudo'].disabled = !hab || !campos['Escudo'].dataset.tiene;
      if (sponsorsOn) for (let n = 1; n <= MAX_SPONSORS; n++) campos[`Sponsor ${n}`].disabled = !hab || !campos[`Sponsor ${n}`].dataset.tiene;
      r('btn-descartar').hidden = !hab;
    }

    function activar() {
      if (personalizado) return;
      personalizado = true;
      programarVista();
      actualizarCampos();
    }

    // Imagen del diseño que viaja con el pedido: se regenera unos instantes después de cada cambio
    let tVista = null;
    function programarVista() {
      if (!personalizado) return;
      clearTimeout(tVista);
      tVista = setTimeout(() => {
        let esp = null;
        try { esp = construirEspalda(); } catch (e) { /* sin espalda en la vista previa */ }
        Promise.all([generarPng(800), esp ? generarPng(800, esp) : Promise.resolve(null)]).then(([blob, blobEsp]) => {
          if (blob) ponerArchivo('Vista previa', new File([blob], 'vista-previa.png', { type: 'image/png' }));
          if (blobEsp) ponerArchivo('Vista previa espalda', new File([blobEsp], 'vista-previa-espalda.png', { type: 'image/png' }));
          actualizarCampos();
        });
      }, 300);
    }

    function cambio() { actualizarCampos(); programarVista(); dibujarEspalda(); }

    /* ---------- logo Dolphin: siempre presente, 3 posiciones en el pecho ---------- */
    const NOMBRE_POS = { izq: 'izquierda', cen: 'centro', der: 'derecha' };
    const MARCA = D.marca;
    const MARCA_W = 56, MARCA_Y = 98;
    let marcaPos = 'izq';
    let marcaTono = 'negro';
    function marcaGeom(pos) {
      const cx = { izq: 191.3, cen: 250, der: 308.7 }[pos];
      const h = MARCA_W / MARCA.ratio;
      return { x: redondear(cx - MARCA_W / 2), y: redondear(MARCA_Y - h / 2), ancho: MARCA_W, alto: redondear(h) };
    }
    function luminancia(hex) {
      const n = parseInt(hex.slice(1), 16);
      const f = v => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
      return 0.2126 * f(n >> 16) + 0.7152 * f((n >> 8) & 255) + 0.0722 * f(n & 255);
    }
    // El tono (negro o blanco) se elige según el color que queda bajo el logo
    function tonoBajoMarca() {
      const g = marcaGeom(marcaPos);
      const pt = typeof DOMPoint === 'function' ? new DOMPoint(g.x + g.ancho / 2, g.y + g.alto / 2) : null;
      const zonas = [...svg.querySelectorAll('[data-grupo],[data-sel]')].filter(z => z.tagName.toLowerCase() !== 'stop').reverse();
      if (pt) for (const f of [...formas].reverse()) {
        if (f.parte !== 'delantero') continue;
        const lp = f.el ? aLocalForma(f, pt) : null;
        if (lp && [...f.el.querySelectorAll('path')].some(p => p.isPointInFill(lp))) return luminancia(f.color) < 0.35 ? 'blanco' : 'negro';
      }
      if (pt) for (const z of zonas) {
        if (typeof z.isPointInFill === 'function' && z.isPointInFill(pt)) {
          const hex = colores[z.dataset.grupo || z.dataset.sel];
          if (hex) return luminancia(hex) < 0.35 ? 'blanco' : 'negro';
        }
      }
      return 'negro';
    }
    function dibujarMarca() {
      let im = svg.querySelector('#marca-dolphin');
      if (!im) {
        im = document.createElementNS(NS_SVG, 'image');
        im.setAttribute('id', 'marca-dolphin');
        im.setAttribute('class', 'marca');
        im.setAttribute('pointer-events', 'none');
        im.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        im.setAttribute('aria-label', 'Logo Dolphin');
        svg.insertBefore(im, svg.querySelector('#luces'));
      }
      const g = marcaGeom(marcaPos);
      marcaTono = tonoBajoMarca();
      const url = MARCA[marcaTono];
      im.setAttribute('x', g.x); im.setAttribute('y', g.y);
      im.setAttribute('width', g.ancho); im.setAttribute('height', g.alto);
      if (im.getAttribute('href') !== url) { im.setAttribute('href', url); im.setAttributeNS(NS_XLINK, 'xlink:href', url); }
    }

    /* ---------- pintar ---------- */
    function pintar() {
      svg.querySelectorAll('[data-grupo]').forEach(z => {
        if (colores[z.dataset.grupo]) z.setAttribute(z.tagName.toLowerCase() === 'stop' ? 'stop-color' : 'fill', colores[z.dataset.grupo]);
      });
      for (const [id] of GRUPOS) {
        const fila = filas.querySelector(`[data-fila="${id}"]`);
        if (!fila) continue;
        const c = colorDe(id);
        fila.querySelector('.cd-hex').textContent = c.toUpperCase();
        fila.querySelector('input[type=color]').value = c;
        fila.querySelectorAll('.cd-paleta button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === c)));
        fila.querySelector('.cd-igualar').hidden = !(vista === 'espalda' && coloresE[id]);
      }
      const rs = filas.closest('details') && filas.closest('details').querySelector('summary');
      if (rs) rs.textContent = vista === 'espalda' ? 'Colores por zona · Espalda' : 'Colores por zona';
      dibujarMarca();
    }

    function poner(grupo, hex) {
      hex = hex.toLowerCase();
      if (vista === 'espalda') coloresE[grupo] = hex; else colores[grupo] = hex;
      activar(); pintar(); cambio();
    }
    function ponerTodo(obj) {
      if (vista === 'espalda') coloresE = { ...INICIAL, ...obj }; else colores = { ...INICIAL, ...obj };
      activar(); pintar(); cambio();
    }
    function igualarAlFrente(grupo) { delete coloresE[grupo]; activar(); pintar(); cambio(); }

    function seleccionar(grupo, sinScroll) {
      activo = grupo;
      for (const sv of [svg, svgEsp]) sv.querySelectorAll('[data-grupo],[data-sel]').forEach(z => z.classList.toggle('sel', (z.dataset.grupo || z.dataset.sel) === grupo));
      filas.querySelectorAll('.cd-fila').forEach(f => f.classList.toggle('activa', f.dataset.fila === grupo));
      const fila = filas.querySelector(`[data-fila="${grupo}"]`);
      if (fila && !sinScroll && fila.scrollIntoView) fila.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    /* ---------- panel ---------- */
    function construirPanel() {
      filas.replaceChildren();
      for (const [id, nombre] of GRUPOS) {
        const fila = document.createElement('div');
        fila.className = 'cd-fila';
        fila.dataset.fila = id;
        fila.innerHTML = '<div class="cd-fila-cab"><button type="button" class="cd-nombre"></button><span class="cd-cab-der"><button type="button" class="cd-igualar" hidden>Igual al frente</button><span class="cd-hex"></span></span></div><div class="cd-paleta"></div>';
        const btnNombre = fila.querySelector('.cd-nombre');
        btnNombre.textContent = nombre;
        btnNombre.addEventListener('click', () => seleccionar(id, true));
        fila.querySelector('.cd-igualar').addEventListener('click', () => { igualarAlFrente(id); seleccionar(id, true); decir(`${nombre}: igual al frente.`); });
        const pal = fila.querySelector('.cd-paleta');
        for (const [hex, nom] of paleta) {
          const b = document.createElement('button');
          b.type = 'button';
          b.dataset.color = hex;
          b.style.background = hex;
          b.setAttribute('aria-label', `${nombre}: ${nom}`);
          b.addEventListener('click', () => { poner(id, hex); seleccionar(id, true); });
          pal.appendChild(b);
        }
        const libre = document.createElement('input');
        libre.type = 'color';
        libre.setAttribute('aria-label', `${nombre}: color personalizado`);
        libre.addEventListener('input', () => poner(id, libre.value));
        libre.addEventListener('focus', () => seleccionar(id, true));
        fila.querySelector('.cd-cab-der').appendChild(libre);
        filas.appendChild(fila);
      }

      combos.replaceChildren();
      for (const combo of modelo.combos) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cd-combo';
        const c = { ...INICIAL, ...combo.c };
        b.innerHTML = '<span class="mini">' + modelo.muestra.map(k => `<i style="background:${c[k]}"></i>`).join('') + '</span>';
        b.append(combo.nombre);
        b.addEventListener('click', () => { ponerTodo(combo.c); decir(`Combinación "${combo.nombre}" aplicada.`); });
        combos.appendChild(b);
      }
    }

    function plantilla(html) {
      const t = document.createElement('template');
      t.innerHTML = html;
      return t.content.firstElementChild;
    }

    function construirModelos() {
      for (const m of MODELOS) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cd-modelo';
        b.dataset.modelo = m.id;
        b.append(plantilla(D.mini[m.id]));
        const t = document.createElement('span');
        t.textContent = m.nombre;
        b.append(t);
        b.addEventListener('click', () => {
          if (m.id === modelo.id) return;
          cargarDiseno(m.id);
          activar();
          cambio();
          decir(`Modelo "${m.nombre}". Los colores vuelven a los originales.`);
        });
        contModelos.appendChild(b);
      }
    }

    /* ---------- cambiar de modelo: se reemplaza el dibujo y se conservan escudo y sponsors ---------- */
    function cargarDiseno(id) {
      modelo = MODELOS.find(m => m.id === id) || MODELOS[0];
      GRUPOS = modelo.grupos;
      INICIAL = modelo.inicial;
      paleta = [...PALETA, ...modelo.extra];
      const logos = [...svg.querySelectorAll('image.logo')];
      logos.forEach(l => l.remove());
      const capa = svg.querySelector('#cd-formas');
      if (capa) capa.remove();
      const raizSvg = plantilla(D.svg[modelo.id]);
      svg.replaceChildren(...[...raizSvg.children].map(n => n.cloneNode(true)));
      const luces = svg.querySelector('#luces');
      logos.forEach(l => svg.insertBefore(l, luces));
      leerTela();
      colocarCapaFormas(capa);
      colores = { ...INICIAL };
      coloresE = {};
      contModelos.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.modelo === modelo.id)));
      construirPanel();
      pintar();
      seleccionar(GRUPOS[0][0], true);
      dibujarGuia();
      sincronizarFormas();
      dibujarEspalda();
    }

    svg.addEventListener('click', e => {
      if (e.target.closest('.cd-forma')) return;
      const z = e.target.closest('[data-grupo],[data-sel]');
      if (z) { if (selActual()) { ponerSel(null); dibujarGuia(); sincronizarFormas(); } seleccionar(z.dataset.grupo || z.dataset.sel); }
    });

    // también se puede tocar una zona de la espalda para elegir su color
    function alTocarZonaEspalda(e) {
      if (e.target.closest('.cd-forma, .cd-texto')) return;
      const z = e.target.closest('[data-grupo],[data-sel]');
      if (z) { if (selActual() || textoSel) { ponerSel(null); textoSel = null; dibujarGuia(); sincronizarFormas(); sincronizarEspalda(); } seleccionar(z.dataset.grupo || z.dataset.sel); }
    }

    /* ---------- acciones ---------- */
    r('btn-reset').addEventListener('click', () => {
      if (vista === 'espalda') { coloresE = {}; activar(); pintar(); cambio(); decir('La espalda vuelve a tener los colores del frente.'); return; }
      ponerTodo(INICIAL); decir('Colores restablecidos.');
    });

    r('btn-azar').addEventListener('click', () => {
      const elegir = () => PALETA[Math.floor(Math.random() * PALETA.length)][0];
      const a = elegir(); let b = elegir(), c = elegir();
      while (b === a) b = elegir();
      while (c === a || c === b) c = elegir();
      const trio = [a, b, c], nuevo = {};
      for (const [id] of GRUPOS) nuevo[id] = id === 'interior' ? INICIAL.interior : trio[Math.floor(Math.random() * 3)];
      ponerTodo(nuevo);
      decir('Combinación al azar aplicada.');
    });

    r('btn-descartar').addEventListener('click', () => {
      personalizado = false;
      clearTimeout(tVista);
      cargarDiseno(MODELOS[0].id);
      if (escudoOn) escudo.quitar();
      if (sponsorsOn) [...sponsors].forEach(s => s.quitarTodo());
      limpiarFormas();
      reiniciarEspalda();
      Object.values(campos).forEach(c => { if (c.type === 'file') ponerArchivo(c.dataset.cdCampo, null); });
      actualizarCampos();
      decir('Sin personalizar: se pedirá la camiseta estándar.');
    });

    function generarPng(lado, origen) {
      return new Promise(resolve => {
        const copia = (origen || svg).cloneNode(true);
        copia.removeAttribute('hidden');
        // la imagen del pedido es un SVG aparte: lleva incrustadas las fuentes que usa
        const usadas = [...new Set(['nombre', 'numero'].filter(c => txt[c].texto).map(c => fuenteDe(txt[c].fuente)))].filter(f => f.datos);
        if (origen && usadas.length) {
          const st = document.createElementNS(NS_SVG, 'style');
          st.textContent = usadas.map(cssFuente).join('');
          copia.insertBefore(st, copia.firstChild);
        }
        copia.querySelectorAll('.cd-guia').forEach(z => z.remove());
        copia.querySelectorAll('.sel, .activo').forEach(z => z.classList.remove('sel', 'activo'));
        copia.setAttribute('width', lado); copia.setAttribute('height', lado);
        if (!copia.getAttribute('xmlns')) copia.setAttribute('xmlns', NS_SVG);
        const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(copia)], { type: 'image/svg+xml' }));
        const img = new Image();
        img.onload = () => {
          const c = document.createElement('canvas'); c.width = c.height = lado;
          c.getContext('2d').drawImage(img, 0, 0, lado, lado);
          URL.revokeObjectURL(url);
          c.toBlob(b => resolve(b), 'image/png');
        };
        img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
        img.src = url;
      });
    }

    r('btn-png').addEventListener('click', async () => {
      const blob = await generarPng(1000, vista === 'espalda' ? construirEspalda() : null);
      if (!blob) { decir('No se pudo generar la imagen.'); return; }
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = vista === 'espalda' ? 'camiseta-espalda.png' : 'camiseta.png';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
      decir('Imagen descargada.');
    });

    /* ---------- logos: escudo y sponsors ---------- */
    let piezas = [], huecos = [];
    function leerTela() {
      const tela = svg.querySelector('#zona-tela');
      piezas = tela ? [tela] : [...svg.querySelectorAll('#cuerpo, #manga-izq, #manga-der')];
      huecos = tela ? [] : [...svg.querySelectorAll('#cuello, #interior-cuello')];
    }

    function cabe(cx, cy, w, h) {
      if (!piezas.length || typeof piezas[0].isPointInFill !== 'function') return true;
      const a = w * 0.45, b = h * 0.45;
      return [[0, 0], [a, 0], [-a, 0], [0, b], [0, -b]].every(([dx, dy]) => {
        const p = new DOMPoint(cx + dx, cy + dy);
        return piezas.some(z => z.isPointInFill(p)) && !huecos.some(z => z.isPointInFill(p));
      });
    }

    function aSvg(e) {
      const sv = svgActual();
      const p = sv.createSVGPoint(); p.x = e.clientX; p.y = e.clientY;
      return p.matrixTransform(sv.getScreenCTM().inverse());
    }

    // Lee la imagen elegida y genera una versión reducida para mostrar en la camiseta; el archivo original viaja con el pedido
    function leerImagen(file, maxLado) {
      return new Promise(resolve => {
        if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { decir('Formato no admitido. Usa PNG, JPG o WebP.'); return resolve(null); }
        if (file.size > MAX_BYTES) { decir('El archivo pesa más de 5 MB. Usa uno más liviano.'); return resolve(null); }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
          const k = Math.min(1, maxLado / Math.max(img.width, img.height));
          const c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(img.width * k));
          c.height = Math.max(1, Math.round(img.height * k));
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          resolve({ dataUrl: c.toDataURL('image/png'), ratio: c.width / c.height, file });
        };
        img.onerror = () => { URL.revokeObjectURL(url); decir('No se pudo leer la imagen.'); resolve(null); };
        img.src = url;
      });
    }

    function crearLogo({ id, nombre, maxLado, defecto, alCambiar, alTocar }) {
      let est = null, im = null, url = null, arrastre = null, original = null;
      const L = { maxLado };

      function dibujar() {
        if (im) {
          im.setAttribute('x', redondear(est.cx - est.w / 2));
          im.setAttribute('y', redondear(est.cy - est.h / 2));
          im.setAttribute('width', redondear(est.w));
          im.setAttribute('height', redondear(est.h));
        }
        if (alCambiar) alCambiar(L);
      }

      function mover(nx, ny) {
        if (cabe(nx, ny, est.w, est.h)) { est.cx = nx; est.cy = ny; }
        else if (cabe(nx, est.cy, est.w, est.h)) { est.cx = nx; }
        else if (cabe(est.cx, ny, est.w, est.h)) { est.cy = ny; }
        else return;
        est.movido = true;
        dibujar();
      }

      L.hay = () => !!est;
      L.movido = () => !!(est && est.movido);
      L.imagen = () => url;
      L.original = () => original;
      L.lado = () => (est ? est.lado : 0);
      L.pos = () => (est ? { x: redondear(est.cx - est.w / 2), y: redondear(est.cy - est.h / 2), ancho: redondear(est.w), alto: redondear(est.h) } : null);

      L.poner = (dataUrl, ratio, file) => {
        const previo = est;
        if (im) im.remove();
        let p = defecto(ratio);
        if (previo) {
          const m = medidas(ratio, previo.lado);
          if (cabe(previo.cx, previo.cy, m.w, m.h)) p = { cx: previo.cx, cy: previo.cy, w: m.w, h: m.h };
        }
        est = { ...p, ratio, lado: Math.max(p.w, p.h), movido: !!(previo && previo.movido) };
        url = dataUrl;
        original = file || null;

        im = document.createElementNS(NS_SVG, 'image');
        im.setAttribute('id', id);
        im.setAttribute('class', 'logo');
        im.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        im.setAttribute('tabindex', '0');
        im.setAttribute('aria-label', `${nombre}. Arrástralo o usa las flechas del teclado para moverlo.`);
        im.setAttribute('href', dataUrl);
        im.setAttributeNS(NS_XLINK, 'xlink:href', dataUrl);
        svg.insertBefore(im, svg.querySelector('#luces'));

        im.addEventListener('pointerdown', e => {
          e.preventDefault();
          const luces = svg.querySelector('#luces');
          if (im.nextElementSibling !== luces) svg.insertBefore(im, luces);
          const pt = aSvg(e);
          arrastre = { id: e.pointerId, dx: est.cx - pt.x, dy: est.cy - pt.y };
          im.setPointerCapture(e.pointerId);
          im.classList.add('activo');
          if (alTocar) alTocar(L);
        });
        im.addEventListener('pointermove', e => {
          if (!arrastre || e.pointerId !== arrastre.id) return;
          const pt = aSvg(e);
          mover(pt.x + arrastre.dx, pt.y + arrastre.dy);
        });
        const soltar = e => {
          if (!arrastre || e.pointerId !== arrastre.id) return;
          arrastre = null; im.classList.remove('activo');
        };
        im.addEventListener('pointerup', soltar);
        im.addEventListener('pointercancel', soltar);
        im.addEventListener('focus', () => { if (alTocar) alTocar(L); });
        im.addEventListener('keydown', e => {
          const paso = e.shiftKey ? 5 : 1;
          const d = { ArrowLeft: [-paso, 0], ArrowRight: [paso, 0], ArrowUp: [0, -paso], ArrowDown: [0, paso] }[e.key];
          if (!d) return;
          e.preventDefault();
          mover(est.cx + d[0], est.cy + d[1]);
        });
        dibujar();
      };

      L.quitar = () => {
        if (im) im.remove();
        im = null; est = null; url = null; arrastre = null; original = null;
        if (alCambiar) alCambiar(L);
      };

      L.centrar = () => {
        if (!est) return;
        const p = defecto(est.ratio);
        Object.assign(est, p);
        est.lado = Math.max(p.w, p.h);
        est.movido = false;
        dibujar();
      };

      L.tamano = v => {
        if (!est) return false;
        const m = medidas(est.ratio, v);
        if (!cabe(est.cx, est.cy, m.w, m.h)) return false;
        est.w = m.w; est.h = m.h; est.lado = v;
        dibujar();
        return true;
      };
      return L;
    }

    /* ---------- escudo ---------- */
    let escudo = { hay: () => false, pos: () => null, quitar() {} };
    if (escudoOn) {
      const zonaE = () => {
        const z = svg.querySelector('#zona-escudo');
        return { zx: +z.getAttribute('x'), zy: +z.getAttribute('y'), zw: +z.getAttribute('width'), zh: +z.getAttribute('height') };
      };
      const archivo = r('archivo-escudo'), btnEscudo = r('btn-escudo'), btnQuitar = r('btn-quitar'), btnPos = r('btn-pos');
      const prev = r('escudo-prev'), ayudaEsc = r('ayuda-escudo'), ajustes = r('escudo-ajustes'), rango = r('escudo-tam');
      const AYUDA_INICIAL = ayudaEsc.textContent;

      escudo = crearLogo({
        id: 'escudo-img', nombre: 'Escudo', maxLado: 256,
        defecto: ratio => {
          let { zx, zy, zw, zh } = zonaE();
          if (marcaPos === 'der') zx = 500 - (zx + zw);   // el logo Dolphin ocupa ese lado: el escudo pasa al contrario
          const ancho = zw / zh > ratio;
          return { cx: zx + zw / 2, cy: zy + zh / 2, w: ancho ? zh * ratio : zw, h: ancho ? zh : zw / ratio };
        },
        alCambiar: L => {
          const p = L.pos();
          prev.style.backgroundImage = p ? `url("${L.imagen()}")` : '';
          ajustes.hidden = btnQuitar.hidden = !p;
          btnEscudo.textContent = p ? 'Cambiar escudo' : 'Subir escudo';
          ayudaEsc.textContent = p ? 'Arrastra el escudo sobre la camiseta para ponerlo donde quieras.' : AYUDA_INICIAL;
          if (p) rango.value = Math.round(L.lado());
          ponerArchivo('Escudo', L.original());
          if (personalizado) cambio();
        }
      });

      btnEscudo.addEventListener('click', () => archivo.click());
      archivo.addEventListener('change', async () => {
        const f = archivo.files[0]; archivo.value = '';
        if (!f) return;
        const img = await leerImagen(f, 256);
        if (img) { activar(); escudo.poner(img.dataUrl, img.ratio, img.file); decir('Escudo agregado. Arrástralo para moverlo.'); }
      });
      btnQuitar.addEventListener('click', () => { escudo.quitar(); decir('Escudo quitado.'); });
      btnPos.addEventListener('click', () => { escudo.centrar(); decir('Escudo de vuelta en el pecho.'); });
      rango.addEventListener('input', () => { if (!escudo.tamano(+rango.value)) rango.value = Math.round(escudo.lado()); });
    }

    /* ---------- sponsors ---------- */
    let sponsors = [];
    if (sponsorsOn) {
      const contSp = r('sponsors'), cuentaSp = r('sp-cuenta'), btnSp = r('btn-sponsor'), archivoSp = r('archivo-sponsor');

      const sincronizarSponsors = () => {
        cuentaSp.textContent = `${sponsors.length} de ${MAX_SPONSORS}`;
        btnSp.disabled = sponsors.length >= MAX_SPONSORS;
        btnSp.textContent = btnSp.disabled ? `Máximo ${MAX_SPONSORS} sponsors` : 'Agregar sponsor';
        if (personalizado) cambio();
      };
      const resaltar = slot => sponsors.forEach(s => s.fila.classList.toggle('activa', s.slot === slot));

      function crearFila(slot, dataUrl) {
        const fila = document.createElement('div');
        fila.className = 'cd-sp-fila';
        fila.innerHTML = `
          <div class="cd-escudo-prev" aria-hidden="true"></div>
          <div class="cd-sp-cuerpo">
            <strong>Sponsor ${slot}</strong>
            <div class="cd-sp-controles">
              <label class="cd-rango">Tamaño <input type="range" min="20" max="150" step="1"></label>
              <button class="cd-btn chico" type="button" data-accion="centrar">Centrar</button>
              <button class="cd-btn chico" type="button" data-accion="quitar">Quitar</button>
            </div>
          </div>`;
        fila.querySelector('.cd-escudo-prev').style.backgroundImage = `url("${dataUrl}")`;
        return fila;
      }

      function agregarSponsor(dataUrl, ratio, file) {
        const slot = [1, 2, 3].find(n => n <= MAX_SPONSORS && !sponsors.some(s => s.slot === n));
        if (!slot) return;
        const logo = crearLogo({
          id: `sponsor-img-${slot}`, nombre: `Sponsor ${slot}`, maxLado: 400,
          defecto: rr => { const [cx, cy] = [[315, 320], [185, 320], [315, 400]][slot - 1]; return { cx, cy, ...medidas(rr, 60) }; },
          alCambiar: L => { ponerArchivo(`Sponsor ${slot}`, L.original()); sincronizarSponsors(); },
          alTocar: () => resaltar(slot)
        });
        const fila = crearFila(slot, dataUrl);
        const item = { slot, logo, fila };
        item.quitarTodo = () => { logo.quitar(); fila.remove(); sponsors = sponsors.filter(s => s !== item); sincronizarSponsors(); };
        sponsors.push(item);
        sponsors.sort((a, b) => a.slot - b.slot).forEach(s => contSp.appendChild(s.fila));

        const tam = fila.querySelector('input[type=range]');
        tam.addEventListener('input', () => { if (!logo.tamano(+tam.value)) tam.value = Math.round(logo.lado()); });
        fila.querySelector('[data-accion=centrar]').addEventListener('click', () => { logo.centrar(); tam.value = Math.round(logo.lado()); resaltar(slot); });
        fila.querySelector('[data-accion=quitar]').addEventListener('click', () => { item.quitarTodo(); decir(`Sponsor ${slot} quitado.`); });

        logo.poner(dataUrl, ratio, file);
        tam.value = Math.round(logo.lado());
        resaltar(slot);
      }

      btnSp.addEventListener('click', () => archivoSp.click());
      archivoSp.addEventListener('change', async () => {
        const f = archivoSp.files[0]; archivoSp.value = '';
        if (!f) return;
        if (sponsors.length >= MAX_SPONSORS) { decir(`Ya tienes ${MAX_SPONSORS} sponsors. Quita uno para agregar otro.`); return; }
        const img = await leerImagen(f, 400);
        if (img) { activar(); agregarSponsor(img.dataUrl, img.ratio, img.file); decir('Sponsor agregado. Arrástralo para moverlo.'); }
      });
      sincronizarSponsors();
    }

    /* ---------- formas: figuras que se agregan, mueven, escalan, giran y pintan; se recortan en la tela ---------- */
    const FORMAS = D.formas || [];
    const formasOn = FORMAS.length > 0 && raiz.dataset.formas !== 'false';
    const MAX_FORMAS = Math.min(30, Math.max(1, parseInt(raiz.dataset.maxFormas, 10) || 15));
    let formas = [];
    let formaSel = null;
    let formasE = [], formaSelE = null;               // formas propias de la espalda
    // fuentes del nombre y número (D.fuentes trae las incrustadas; si no, una genérica gruesa)
    const FUENTES = (D.fuentes && D.fuentes.length) ? D.fuentes : [{ id: 'bloque', nombre: 'Bloque', familia: "'Arial Black', Impact, 'Helvetica Neue', Arial, sans-serif", peso: 900 }];
    const fuenteDe = id => FUENTES.find(f => f.id === id) || FUENTES[0];
    const cssFuente = f => `@font-face{font-family:'${f.css}';src:url(${f.datos}) format('woff2');font-weight:${f.peso};font-style:normal;font-display:swap}`;
    if (FUENTES.some(f => f.datos) && !document.getElementById('cd-fuentes')) {
      const st = document.createElement('style');
      st.id = 'cd-fuentes';
      st.textContent = FUENTES.filter(f => f.datos).map(cssFuente).join('');
      document.head.appendChild(st);
    }
    const nuevoTexto = clave => ({ texto: '', cx: 250, cy: clave === 'nombre' ? 100 : 240, tam: 100, giro: 0, arco: 0, color: null, fuente: FUENTES[0].id, el: null });
    let txt = { nombre: nuevoTexto('nombre'), numero: nuevoTexto('numero') };
    let textoSel = null;
    const reiniciarTextos = () => { txt = { nombre: nuevoTexto('nombre'), numero: nuevoTexto('numero') }; textoSel = null; };
    let vista = 'frente';
    const enEsp = () => vista === 'espalda';
    const lista = () => (enEsp() ? formasE : formas);
    const setLista = a => { if (enEsp()) formasE = a; else formas = a; };
    const selActual = () => (enEsp() ? formaSelE : formaSel);
    const ponerSel = f => { if (enEsp()) formaSelE = f; else formaSel = f; };
    const svgActual = () => (enEsp() ? svgEsp : svg);
    const nomParte = (c, corto) => (enEsp() && c === 'delantero' ? (corto ? 'espalda' : 'Espalda') : PARTES[c][corto ? 'corto' : 'nombre']);
    let formaUid = 0;
    let colorFormaUltimo = null;
    const defForma = id => FORMAS.find(f => f.id === id);
    const limitar = (v, a, b) => Math.min(b, Math.max(a, v));

    // Cada forma pertenece a UNA parte de la camiseta y se corta en sus bordes (las costuras de la manga son el límite).
    const SEAM_IZQ = [[102.8, 66.8], [118.2, 124.9], [131.9, 162.3], [134.1, 188.7]];
    const SEAM_DER = SEAM_IZQ.map(([x, y]) => [500 - x, y]);
    const PARTES = {
      'delantero': { nombre: 'Delantero', corto: 'delantero', centro: [250, 230], x: [135, 365], y: [25, 475],
        poli: [[102.8, -50], ...SEAM_IZQ, [122, 188.7], [122, 560], [378, 560], [378, 188.7], ...[...SEAM_DER].reverse(), [397.2, -50]] },
      'manga-izq': { nombre: 'Manga izq.', corto: 'manga izquierda', centro: [92, 128], x: [52, 135], y: [66, 190],
        poli: [[-50, -50], [102.8, -50], ...SEAM_IZQ, [134.1, 260], [-50, 260]] },
      'manga-der': { nombre: 'Manga der.', corto: 'manga derecha', centro: [408, 128], x: [365, 448], y: [66, 190],
        poli: [[550, -50], [397.2, -50], ...SEAM_DER, [365.9, 260], [550, 260]] }
    };
    const ORDEN_PARTES = ['delantero', 'manga-izq', 'manga-der'];

    function transformForma(f) {
      const k = f.tam / 100;
      return `translate(${redondear(f.cx)} ${redondear(f.cy)}) rotate(${redondear(f.giro)}) scale(${redondear(k * f.prop)} ${redondear(k)})`;
    }

    // punto del lienzo -> coordenadas propias de la forma (inversa de transformForma)
    function aLocalForma(f, pt) {
      if (typeof DOMPoint !== 'function') return null;
      const k = f.tam / 100, a = -f.giro * Math.PI / 180;
      const dx = pt.x - f.cx, dy = pt.y - f.cy;
      return new DOMPoint((dx * Math.cos(a) - dy * Math.sin(a)) / (k * f.prop), (dx * Math.sin(a) + dy * Math.cos(a)) / k);
    }

    // Capa que contiene las formas: va justo antes del cuello (el cuello, las sombras, las costuras y los logos quedan encima)
    // y se recorta con la silueta de la tela, como en una sublimación real.
    function colocarCapaFormas(previa) {
      if (!formasOn) return;
      let g = previa || svg.querySelector('#cd-formas');
      if (!g) {
        g = document.createElementNS(NS_SVG, 'g');
        g.setAttribute('id', 'cd-formas');
        g.setAttribute('clip-path', 'url(#cd-recorte-formas)');
      }
      svg.querySelectorAll('#cd-recorte-formas').forEach(n => n.remove());
      const cp = document.createElementNS(NS_SVG, 'clipPath');
      cp.setAttribute('id', 'cd-recorte-formas');
      for (const z of piezas) {
        const p = document.createElementNS(NS_SVG, 'path');
        p.setAttribute('d', z.getAttribute('d'));
        p.setAttribute('clip-rule', 'evenodd');
        const t = z.getAttribute('transform');
        if (t) p.setAttribute('transform', t);
        cp.appendChild(p);
      }
      const ref = svg.querySelector('#cuello') || svg.querySelector('#sombras');
      svg.insertBefore(cp, ref);
      svg.insertBefore(g, ref);
      // un grupo por parte, cada uno recortado con el polígono de esa parte
      svg.querySelectorAll('.cd-recorte-parte').forEach(n => n.remove());
      for (const clave of ORDEN_PARTES) {
        const c = document.createElementNS(NS_SVG, 'clipPath');
        c.setAttribute('id', `cd-parte-${clave}`);
        c.setAttribute('class', 'cd-recorte-parte');
        const pl = document.createElementNS(NS_SVG, 'polygon');
        pl.setAttribute('points', PARTES[clave].poli.map(([x, y]) => `${x},${y}`).join(' '));
        c.appendChild(pl);
        svg.insertBefore(c, g);
        if (!g.querySelector(`[data-parte="${clave}"]`)) {
          const sub = document.createElementNS(NS_SVG, 'g');
          sub.setAttribute('data-parte', clave);
          sub.setAttribute('clip-path', `url(#cd-parte-${clave})`);
          g.appendChild(sub);
        }
      }
    }
    const grupoParte = parte => svg.querySelector(`#cd-formas [data-parte="${parte}"]`);

    function elementoForma(f) {
      const def = defForma(f.tipo);
      const g = nodo('g', { class: 'cd-forma', 'data-uid': f.uid, tabindex: '0', role: 'img', fill: f.color, transform: transformForma(f),
        'aria-label': `${def.nombre}. Arrástrala o usa las flechas del teclado para moverla.` });
      for (const d of def.paths) {
        const p = nodo('path', { d });
        if (def.regla) p.setAttribute('fill-rule', def.regla);
        g.appendChild(p);
      }
      return g;
    }

    function dibujarForma(f) {
      if (f.lado === 'espalda') {
        const el = svgEsp.querySelector(`[data-uid="${f.uid}"]`);
        if (!el) { dibujarEspalda(); return; }
        f.el = el;
        el.setAttribute('fill', f.color); el.setAttribute('transform', transformForma(f));
        return;
      }
      if (!f.el) {
        const def = defForma(f.tipo);
        const g = document.createElementNS(NS_SVG, 'g');
        g.setAttribute('class', 'cd-forma');
        g.setAttribute('tabindex', '0');
        g.setAttribute('role', 'img');
        g.setAttribute('aria-label', `${def.nombre}. Arrástrala o usa las flechas del teclado para moverla.`);
        for (const d of def.paths) {
          const p = document.createElementNS(NS_SVG, 'path');
          p.setAttribute('d', d);
          if (def.regla) p.setAttribute('fill-rule', def.regla);
          g.appendChild(p);
        }
        enlazarForma(f, g);
        f.el = g;
        grupoParte(f.parte).appendChild(g);
      }
      f.el.setAttribute('fill', f.color);
      f.el.setAttribute('transform', transformForma(f));
    }

    // Contorno punteado de la forma elegida (no sale en la imagen del pedido)
    function dibujarGuia() {
      svg.querySelectorAll('.cd-guia').forEach(n => n.remove());
      svgEsp.querySelectorAll('.cd-guia').forEach(n => n.remove());
      let el = null, tr = '';
      if (enEsp() && textoSel && txt[textoSel].el) { el = txt[textoSel].el; tr = transformTexto(txt[textoSel]); }
      else { const f = selActual(); if (f && f.el) { el = f.el; tr = transformForma(f); } }
      if (!el) return;
      let bb;
      try { bb = el.getBBox(); } catch (e) { return; }
      const g = document.createElementNS(NS_SVG, 'g');
      g.setAttribute('class', 'cd-guia');
      g.setAttribute('pointer-events', 'none');
      g.setAttribute('transform', tr);
      const rc = document.createElementNS(NS_SVG, 'rect');
      rc.setAttribute('x', bb.x); rc.setAttribute('y', bb.y); rc.setAttribute('width', bb.width); rc.setAttribute('height', bb.height);
      g.appendChild(rc);
      svgActual().appendChild(g);
    }

    function formasCambio() {
      dibujarMarca();
      if (!personalizado) return;
      if (enEsp()) { actualizarCampos(); programarVista(); } else cambio();   // en la espalda no se redibuja: se está arrastrando el elemento
    }

    function enlazarForma(f, g) {
      let arr = null;
      g.addEventListener('pointerdown', e => {
        e.preventDefault();
        seleccionarForma(f.uid);
        const pt = aSvg(e);
        arr = { id: e.pointerId, dx: f.cx - pt.x, dy: f.cy - pt.y };
        g.setPointerCapture(e.pointerId);
        g.classList.add('activo');
      });
      g.addEventListener('pointermove', e => {
        if (!arr || e.pointerId !== arr.id) return;
        const pt = aSvg(e);
        const P = PARTES[f.parte];
        f.cx = limitar(pt.x + arr.dx, P.x[0], P.x[1]);
        f.cy = limitar(pt.y + arr.dy, P.y[0], P.y[1]);
        dibujarForma(f); dibujarGuia(); formasCambio();
      });
      const soltar = e => {
        if (!arr || e.pointerId !== arr.id) return;
        arr = null; g.classList.remove('activo');
      };
      g.addEventListener('pointerup', soltar);
      g.addEventListener('pointercancel', soltar);
      g.addEventListener('focus', () => { if (selActual() !== f) seleccionarForma(f.uid); });
      g.addEventListener('keydown', e => {
        if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); quitarForma(f); return; }
        const paso = e.shiftKey ? 5 : 1;
        const d = { ArrowLeft: [-paso, 0], ArrowRight: [paso, 0], ArrowUp: [0, -paso], ArrowDown: [0, paso] }[e.key];
        if (!d) return;
        e.preventDefault();
        const P = PARTES[f.parte];
        f.cx = limitar(f.cx + d[0], P.x[0], P.x[1]);
        f.cy = limitar(f.cy + d[1], P.y[0], P.y[1]);
        dibujarForma(f); dibujarGuia(); formasCambio();
      });
    }

    function colorInicialForma() {
      if (colorFormaUltimo) return colorFormaUltimo;
      const base = colores[GRUPOS[0][0]] || '#ffffff';
      return luminancia(base) < 0.35 ? '#ffffff' : '#111111';
    }

    function agregarForma(tipo, origen) {
      if (lista().length >= MAX_FORMAS) { decir(`Máximo ${MAX_FORMAS} formas. Quita una para agregar otra.`); return null; }
      const def = defForma(tipo);
      if (!def) return null;
      const n = lista().length;
      const lado = enEsp() ? 'espalda' : 'frente';
      const f = origen
        ? { ...origen, el: null, uid: ++formaUid, lado, cx: limitar(origen.cx + 18, PARTES[origen.parte].x[0], PARTES[origen.parte].x[1]), cy: limitar(origen.cy + 18, PARTES[origen.parte].y[0], PARTES[origen.parte].y[1]) }
        : { uid: ++formaUid, lado, tipo, parte: 'delantero', cx: 250 + (n % 4) * 14, cy: 230 + (n % 4) * 14, tam: def.tam, prop: 1, giro: def.giro || 0, color: colorInicialForma(), el: null };
      colorFormaUltimo = f.color;
      lista().push(f);
      dibujarForma(f);
      activar();
      seleccionarForma(f.uid);
      formasCambio();
      return f;
    }

    function quitarForma(f) {
      if (f.el) f.el.remove();
      setLista(lista().filter(x => x !== f));
      if (selActual() === f) ponerSel(lista()[lista().length - 1] || null);
      dibujarGuia(); sincronizarFormas(); formasCambio();
      decir('Forma quitada.');
    }

    function moverAParte(f, parte) {
      if (f.parte === parte) return;
      f.parte = parte;
      const P = PARTES[parte];
      f.cx = P.centro[0]; f.cy = P.centro[1];
      if (parte !== 'delantero') f.tam = Math.min(f.tam, 100);   // en una manga cabe poco: se achica para que se vea entera
      if (f.lado === 'espalda') dibujarEspalda(); else grupoParte(parte).appendChild(f.el);
      dibujarForma(f); dibujarGuia(); sincronizarFormas(); formasCambio();
    }

    function limpiarFormas() {
      [...formas, ...formasE].forEach(f => { if (f.el) f.el.remove(); });
      formas = []; formasE = []; formaSel = null; formaSelE = null; colorFormaUltimo = null;
      reiniciarTextos();
      dibujarGuia(); sincronizarFormas();
    }

    function seleccionarForma(uid) {
      ponerSel(lista().find(f => f.uid === uid) || null);
      if (enEsp() && selActual()) textoSel = null;
      dibujarGuia(); sincronizarFormas(); sincronizarEspalda();
    }

    // Orden de las capas: la última de la lista es la que queda arriba
    function ordenarForma(f, alFrente) {
      setLista(lista().filter(x => x !== f));
      if (f.lado === 'espalda') {
        if (alFrente) lista().push(f); else lista().unshift(f);
        dibujarEspalda();
      } else {
        const capa = grupoParte(f.parte);
        if (alFrente) { formas.push(f); capa.appendChild(f.el); } else { formas.unshift(f); capa.insertBefore(f.el, capa.firstChild); }
      }
      sincronizarFormas(); formasCambio();
    }

    /* panel de formas */
    let pnlFormas = null;
    function construirFormasUI() {
      const det = document.createElement('details');
      det.className = 'cd-bloque';
      det.open = true;
      det.dataset.r = 'bloque-formas';
      det.innerHTML = `
        <summary>Formas <span class="cd-cuenta" data-k="cuenta"></span></summary>
        <p class="cd-ayuda cd-ayuda-arriba">Toca una forma para agregarla. Puedes repetir la misma. Arrástrala sobre la camiseta; abajo cambias color, tamaño y giro. Cada forma se queda en una parte (delantero o manga) y se corta en sus bordes.</p>
        <div class="cd-formas-galeria" role="group" aria-label="Formas disponibles" data-k="galeria"></div>
        <div class="cd-fm-lista" role="group" aria-label="Formas en la camiseta" data-k="lista"></div>
        <div class="cd-fm-editor" data-k="editor" hidden>
          <strong class="cd-fm-titulo" data-k="titulo"></strong>
          <div class="cd-fm-partes" role="group" aria-label="Parte de la camiseta donde va la forma" data-k="partes"></div>
          <div class="cd-fm-paleta" role="group" aria-label="Color de la forma" data-k="paleta"></div>
          <div class="cd-fm-rangos">
            <label class="cd-rango">Tamaño <input type="range" data-k="tam" min="20" max="700" step="1"></label>
            <label class="cd-rango">Ancho <input type="range" data-k="prop" min="20" max="400" step="1"></label>
            <label class="cd-rango">Giro <input type="range" data-k="giro" min="-180" max="180" step="1"></label>
          </div>
          <div class="cd-fm-botones">
            <button class="cd-btn chico" type="button" data-accion="duplicar">Duplicar</button>
            <button class="cd-btn chico" type="button" data-accion="frente">Al frente</button>
            <button class="cd-btn chico" type="button" data-accion="atras">Atrás</button>
            <button class="cd-btn chico" type="button" data-accion="quitar">Quitar</button>
          </div>
        </div>`;
      const k = n => det.querySelector(`[data-k="${n}"]`);
      pnlFormas = { det, k, paletaUsada: null };

      for (const def of FORMAS) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-forma-btn';
        b.title = def.nombre;
        b.setAttribute('aria-label', `Agregar ${def.nombre}`);
        b.innerHTML = `<svg viewBox="-52 -52 104 104" aria-hidden="true" focusable="false"><g fill="currentColor"${def.regla ? ` fill-rule="${def.regla}"` : ''}>${def.paths.map(d => `<path d="${d}"/>`).join('')}</g></svg><span>${def.nombre}</span>`;
        b.addEventListener('click', () => { if (agregarForma(def.id)) decir(`${def.nombre} agregada. Arrástrala para moverla.`); });
        k('galeria').appendChild(b);
      }

      for (const clave of ORDEN_PARTES) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-btn chico'; b.dataset.parte = clave; b.textContent = PARTES[clave].nombre;
        b.addEventListener('click', () => { if (selActual()) { moverAParte(selActual(), clave); decir(`Forma en ${nomParte(clave, true)}. No pasa a otra parte de la camiseta.`); } });
        k('partes').appendChild(b);
      }
      for (const campoRango of ['tam', 'prop', 'giro']) {
        k(campoRango).addEventListener('input', e => {
          const f = selActual(); if (!f) return;
          const v = +e.target.value;
          if (campoRango === 'prop') f.prop = v / 100; else f[campoRango] = v;
          dibujarForma(f); dibujarGuia(); formasCambio();
        });
      }
      det.querySelector('[data-accion="duplicar"]').addEventListener('click', () => { if (selActual()) { const c = agregarForma(selActual().tipo, selActual()); if (c) decir('Forma duplicada.'); } });
      det.querySelector('[data-accion="frente"]').addEventListener('click', () => { if (selActual()) { ordenarForma(selActual(), true); decir('Forma al frente.'); } });
      det.querySelector('[data-accion="atras"]').addEventListener('click', () => { if (selActual()) { ordenarForma(selActual(), false); decir('Forma atrás.'); } });
      det.querySelector('[data-accion="quitar"]').addEventListener('click', () => { if (selActual()) quitarForma(selActual()); });

      const antes = r('bloque-escudo') || raiz.querySelector('.cd-acciones');
      antes.parentNode.insertBefore(det, antes);
    }

    function ponerColorForma(hex) {
      const f = selActual(); if (!f) return;
      f.color = hex.toLowerCase(); colorFormaUltimo = f.color;
      dibujarForma(f); sincronizarFormas(); formasCambio();
    }

    function sincronizarFormas() {
      if (!pnlFormas) return;
      const { k } = pnlFormas;
      const L = lista();
      k('cuenta').textContent = `${enEsp() ? 'Espalda' : 'Frente'} · ${L.length} de ${MAX_FORMAS}`;
      const lleno = L.length >= MAX_FORMAS;
      k('galeria').querySelectorAll('button').forEach(b => { b.disabled = lleno; });

      const listaEl = k('lista');
      listaEl.replaceChildren();
      L.forEach((f, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-fm-chip';
        b.setAttribute('aria-pressed', String(f === selActual()));
        const punto = document.createElement('i'); punto.style.background = f.color;
        b.append(punto, `${i + 1}. ${defForma(f.tipo).nombre}${f.parte !== 'delantero' ? ' · ' + nomParte(f.parte, true) : ''}`);
        b.addEventListener('click', () => seleccionarForma(f.uid));
        listaEl.appendChild(b);
      });

      const ed = k('editor');
      ed.hidden = !selActual();
      if (!selActual()) return;
      k('partes').querySelectorAll('button').forEach(b => { b.textContent = nomParte(b.dataset.parte); });
      k('titulo').textContent = defForma(selActual().tipo).nombre;
      k('partes').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.parte === selActual().parte)));
      k('tam').value = Math.round(selActual().tam);
      k('prop').value = Math.round(selActual().prop * 100);
      k('giro').value = Math.round(selActual().giro);

      const pal = k('paleta');
      if (pnlFormas.paletaUsada !== paleta) {
        pnlFormas.paletaUsada = paleta;
        pal.replaceChildren();
        for (const [hex, nom] of paleta) {
          const b = document.createElement('button');
          b.type = 'button'; b.dataset.color = hex; b.style.background = hex;
          b.setAttribute('aria-label', `Color ${nom}`);
          b.addEventListener('click', () => ponerColorForma(hex));
          pal.appendChild(b);
        }
        const libre = document.createElement('input');
        libre.type = 'color'; libre.setAttribute('aria-label', 'Color personalizado de la forma');
        libre.addEventListener('input', () => ponerColorForma(libre.value));
        pal.appendChild(libre);
      }
      pal.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === selActual().color)));
      const libre = pal.querySelector('input[type=color]');
      if (libre) libre.value = selActual().color;
    }

    if (formasOn) construirFormasUI();

    /* ---------- espalda: se arma sola a partir del frente (igual, volteada o lisa) ---------- */
    let espModo = 'igual';
    let espColor = null;           // null = automático (color principal del modelo)
    const NOMBRE_ESP = { igual: 'igual al frente', volteada: 'volteada', lisa: 'lisa' };
    const colorEspaldaAuto = () => colorEsp(modelo.muestra && modelo.muestra[0]) || '#ffffff';
    const colorEspalda = () => espColor || colorEspaldaAuto();
    const ESPEJO = 'translate(500 0) scale(-1 1)';

    // color del tejido del frente en un punto (para continuar el diseño bajo el escote en la espalda)
    function colorEn(x, y, espalda) {
      if (typeof DOMPoint !== 'function') return null;
      const pt = new DOMPoint(x, y);
      const zonas = [...svg.querySelectorAll('[data-grupo],[data-sel]')]
        .filter(z => z.tagName.toLowerCase() !== 'stop' && !['cuello', 'interior', 'etiqueta'].includes(z.dataset.grupo)).reverse();
      for (const z of zonas) {
        if (typeof z.isPointInFill === 'function' && z.isPointInFill(pt)) {
          const g = z.dataset.grupo || z.dataset.sel;
          const hex = espalda ? colorEsp(g) : colores[g];
          if (hex) return hex;
        }
      }
      return null;
    }

    function nodo(tag, attrs) {
      const e = document.createElementNS(NS_SVG, tag);
      for (const k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }

    function colorTextoEfectivo(clave) {
      const T = txt[clave];
      if (T && T.color) return T.color;
      const base = espModo === 'lisa' ? colorEspalda() : (colorEn(250, 230, true) || colorEspaldaAuto());
      return luminancia(base) < 0.35 ? '#ffffff' : '#111111';
    }

    const transformTexto = T => `translate(${redondear(T.cx)} ${redondear(T.cy)}) rotate(${redondear(T.giro)}) scale(${redondear(T.tam / 100)})`;
    const tamBaseTexto = c => (c === 'nombre' ? Math.min(34, 190 / (Math.max(1, txt.nombre.texto.length) * 0.82)) : (txt.numero.texto.length > 1 ? 140 : 160));

    // el texto (con arco opcional) en coordenadas propias: base en (0,0), centrado
    function elementoTexto(clave) {
      const T = txt[clave], F = fuenteDe(T.fuente);
      const g = nodo('g', { class: 'cd-texto', 'data-texto': clave, tabindex: '0', role: 'img', transform: transformTexto(T), fill: colorTextoEfectivo(clave),
        'text-anchor': 'middle', 'font-family': F.familia, 'font-weight': F.peso || 700,
        'aria-label': `${clave === 'nombre' ? 'Nombre' : 'Número'}: ${T.texto}. Arrástralo o usa las flechas del teclado para moverlo.` });
      if (F.estilo) g.setAttribute('font-style', F.estilo);
      const t = nodo('text', { 'font-size': Math.round(tamBaseTexto(clave) * 10) / 10, 'letter-spacing': F.espaciado || 0 });
      if (clave === 'nombre' && T.arco) {
        const R = 6500 / Math.abs(T.arco), d2r = Math.PI / 180, arriba = T.arco > 0;
        const pt = a => (arriba ? [R * Math.cos(a * d2r), R + R * Math.sin(a * d2r)] : [R * Math.cos(a * d2r), -R + R * Math.sin(a * d2r)]).map(v => Math.round(v * 100) / 100);
        const [p1, p2] = arriba ? [pt(-240), pt(60)] : [pt(240), pt(-60)];
        const id = 'cd-arco-nombre';
        const defs = nodo('defs', {});
        defs.appendChild(nodo('path', { id, d: `M ${p1[0]} ${p1[1]} A ${R} ${R} 0 1 ${arriba ? 1 : 0} ${p2[0]} ${p2[1]}`, fill: 'none' }));
        g.appendChild(defs);
        const tp = nodo('textPath', { href: '#' + id, startOffset: '50%' });
        tp.setAttributeNS(NS_XLINK, 'xlink:href', '#' + id);
        tp.textContent = T.texto;
        t.appendChild(tp);
      } else {
        t.setAttribute('x', 0); t.setAttribute('y', 0);
        t.textContent = T.texto;
      }
      g.appendChild(t);
      return g;
    }

    // Devuelve un <svg> con la espalda (sin añadirlo a la página)
    function construirEspalda() {
      const esp = nodo('svg', { viewBox: '0 0 500 500', role: 'img', 'aria-label': 'Camiseta Dolphin, vista trasera' });
      esp.setAttribute('xmlns', NS_SVG);
      const hijos = [...svg.children];
      const etiqueta = n => n.tagName.toLowerCase();
      const esDefs = n => ['defs', 'clippath'].includes(etiqueta(n));
      const SOMBREADO = ['sombras', 'luces', 'sombras-mangas', 'costuras'];
      const FUERA = ['cuello', 'interior-cuello', 'etiqueta', 'zona-escudo', 'zona-numero', 'zona-tela', 'marca-dolphin'];
      const arte = hijos.filter(n => !esDefs(n) && !SOMBREADO.includes(n.id) && !FUERA.includes(n.id) && !n.classList.contains('logo') && !n.classList.contains('cd-guia'));
      const sombreado = hijos.filter(n => SOMBREADO.includes(n.id));
      const cuelloFrente = ['cuello', 'interior-cuello', 'etiqueta'].map(i => svg.querySelector('#' + i)).filter(Boolean);
      const tela = !!svg.querySelector('#zona-tela');

      hijos.filter(esDefs).forEach(n => esp.appendChild(n.cloneNode(true)));
      // la silueta de los modelos trazados trae un hueco por el escote delantero: en la espalda no existe
      esp.querySelectorAll('#recorte-silueta path').forEach(p => {
        const partes = p.getAttribute('d').split(/(?=M)/);
        if (partes.length > 1) p.setAttribute('d', partes[0]);
      });
      // las formas también pueden llegar hasta el borde del cuello trasero
      const cpFormas = esp.querySelector('#cd-recorte-formas');
      if (cpFormas) cuelloFrente.forEach(n => cpFormas.appendChild(nodo('path', { d: n.getAttribute('d'), 'clip-rule': 'evenodd' })));

      const poli = pts => pts.map(([x, y]) => `${x},${y}`).join(' ');
      const cT = nodo('clipPath', { id: 'cd-esp-torso' });
      cT.appendChild(nodo('polygon', { points: poli(PARTES['delantero'].poli) }));
      const cM = nodo('clipPath', { id: 'cd-esp-mangas' });
      cM.appendChild(nodo('polygon', { points: poli(PARTES['manga-izq'].poli) }));
      cM.appendChild(nodo('polygon', { points: poli(PARTES['manga-der'].poli) }));
      esp.append(cT, cM);

      const limpiar = e => {
        e.removeAttribute('id');
        e.removeAttribute('tabindex');
        e.querySelectorAll('[id],[tabindex]').forEach(x => { x.removeAttribute('id'); x.removeAttribute('tabindex'); });
        return e;
      };

      // fabricar la tela que falta bajo el escote delantero (solo modelos trazados desde foto)
      const parche = () => {
        const cp = nodo('clipPath', { id: 'cd-esp-parche' });
        cuelloFrente.forEach(n => cp.appendChild(nodo('path', { d: n.getAttribute('d'), 'clip-rule': 'evenodd' })));
        esp.appendChild(cp);
        const g = nodo('g', { 'clip-path': 'url(#cd-esp-parche)' });
        const respaldo = colorEspaldaAuto();
        let ini = 184, ult = colorEn(184, 80, true) || respaldo;
        for (let x = 186; x <= 316; x += 2) {
          const c = colorEn(Math.min(x, 316), 80, true) || respaldo;
          if (c !== ult || x >= 316) {
            g.appendChild(nodo('rect', { x: ini, y: 20, width: x - ini + 0.6, height: 70, fill: ult }));
            ini = x; ult = c;
          }
        }
        return g;
      };

      const capa = (nodos, transform, conParche) => {
        const g = nodo('g', transform ? { transform } : {});
        for (const n of nodos) {
          if (conParche && tela && n.id === 'cd-formas') g.appendChild(parche());
          g.appendChild(limpiar(n.cloneNode(true)));
        }
        return g;
      };

      // torso: según el modo; mangas: siempre las mismas piezas vistas desde el otro lado (cambian de lado)
      const capaT = nodo('g', { 'clip-path': 'url(#cd-esp-torso)' });
      if (espModo === 'lisa') {
        const sil = esp.querySelector('#recorte-silueta') ? 'recorte-silueta' : 'recorte-torso';
        const g = nodo('g', { 'clip-path': `url(#${sil})` });
        g.appendChild(nodo('rect', { x: 0, y: 0, width: 500, height: 500, fill: colorEspalda() }));
        capaT.appendChild(g);
      } else {
        capaT.appendChild(capa(arte, espModo === 'volteada' ? ESPEJO : '', true));
      }
      const capaM = nodo('g', { 'clip-path': 'url(#cd-esp-mangas)' });
      capaM.appendChild(capa(arte, ESPEJO, false));
      const cN = nodo('clipPath', { id: 'cd-esp-cuello' });
      cN.appendChild(nodo('path', { 'clip-rule': 'evenodd', d: 'M-100 -100H600V600H-100ZM176 -50L324 -50L324 31L322 31Q250 47 178 31L176 31Z' }));
      esp.appendChild(cN);
      esp.append(capaT, capaM);

      // formas propias de la espalda (encima del fondo)
      if (formasE.length) {
        const gE = nodo('g', { 'clip-path': 'url(#cd-recorte-formas)' });
        const subs = {};
        for (const c of ORDEN_PARTES) { subs[c] = nodo('g', { 'data-parte': c, 'clip-path': `url(#cd-parte-${c})` }); gE.appendChild(subs[c]); }
        for (const f of formasE) subs[f.parte].appendChild(elementoForma(f));
        esp.appendChild(gE);
      }
      // nombre y número (dentro del torso de la espalda, como una sublimación real)
      if (txt.nombre.texto || txt.numero.texto) {
        const gT = nodo('g', { 'clip-path': 'url(#cd-recorte-formas)' });
        const sub = nodo('g', { 'clip-path': 'url(#cd-parte-delantero)' });
        gT.appendChild(sub);
        for (const c of ['nombre', 'numero']) if (txt[c].texto) sub.appendChild(elementoTexto(c));
        esp.appendChild(gT);
      }

      // cuello trasero (según foto real de Dolphin): una banda curva sólida, con los extremos hacia los hombros y el centro más bajo.
      // No se ve el interior; sobre la banda no hay tela (queda el fondo).
      esp.appendChild(nodo('path', { fill: colorEsp('cuello') || '#ffffff', stroke: 'rgba(0,0,0,.2)', 'stroke-width': 0.8, 'stroke-linejoin': 'round',
        d: 'M178 31Q250 47 322 31C326 33 326 43 322 45Q250 61 178 45C174 43 174 33 178 31Z' }));

      sombreado.forEach(n => {
        const c = limpiar(n.cloneNode(true));
        c.querySelectorAll('ellipse').forEach(el => {   // sombra del escote delantero: no corresponde en la espalda
          const cx = +el.getAttribute('cx'), cy = +el.getAttribute('cy');
          if (Math.abs(cx - 250) < 6 && cy > 60 && cy < 95) el.remove();
        });
        esp.appendChild(c);
      });
      // todo el contenido queda dentro del recorte que deja libre el hueco del cuello
      const gTodo = nodo('g', { 'clip-path': 'url(#cd-esp-cuello)' });
      [...esp.children].filter(n => !['defs', 'clippath'].includes(etiqueta(n))).forEach(n => gTodo.appendChild(n));
      esp.appendChild(gTodo);
      // colores propios de la espalda (zonas y degradados)
      esp.querySelectorAll('[data-grupo]').forEach(z => {
        const h = coloresE[z.dataset.grupo];
        if (h) z.setAttribute(z.tagName.toLowerCase() === 'stop' ? 'stop-color' : 'fill', h);
      });
      return esp;
    }

    function prefijarIds(raiz, pref) {
      raiz.querySelectorAll('[id]').forEach(e => e.setAttribute('id', pref + e.id));
      raiz.querySelectorAll('*').forEach(e => {
        for (const a of ['clip-path', 'fill', 'stroke', 'mask', 'filter']) {
          const v = e.getAttribute(a);
          if (v && v.indexOf('url(#') >= 0) e.setAttribute(a, v.replace(/url\(#([^)]+)\)/g, `url(#${pref}$1)`));
        }
        for (const a of ['href', 'xlink:href']) {
          const v = e.getAttribute(a);
          if (v && v[0] === '#') e.setAttribute(a, '#' + pref + v.slice(1));
        }
      });
    }

    function actualizarTexto(clave, estructural) {
      const T = txt[clave];
      if (estructural || !T.el) dibujarEspalda();
      else { T.el.setAttribute('transform', transformTexto(T)); T.el.setAttribute('fill', colorTextoEfectivo(clave)); dibujarGuia(); }
      formasCambio();
    }

    function seleccionarTexto(clave) {
      textoSel = clave; formaSelE = null;
      dibujarGuia(); sincronizarFormas(); sincronizarEspalda();
    }

    const LIM_TEXTO = { x: [135, 365], y: [25, 475] };
    function enlazarTexto(clave, g) {
      const T = txt[clave];
      let arr = null;
      g.addEventListener('pointerdown', e => {
        e.preventDefault();
        seleccionarTexto(clave);
        const pt = aSvg(e);
        arr = { id: e.pointerId, dx: T.cx - pt.x, dy: T.cy - pt.y };
        g.setPointerCapture(e.pointerId);
        g.classList.add('activo');
      });
      g.addEventListener('pointermove', e => {
        if (!arr || e.pointerId !== arr.id) return;
        const pt = aSvg(e);
        T.cx = limitar(pt.x + arr.dx, LIM_TEXTO.x[0], LIM_TEXTO.x[1]);
        T.cy = limitar(pt.y + arr.dy, LIM_TEXTO.y[0], LIM_TEXTO.y[1]);
        actualizarTexto(clave);
      });
      const soltar = e => { if (!arr || e.pointerId !== arr.id) return; arr = null; g.classList.remove('activo'); };
      g.addEventListener('pointerup', soltar);
      g.addEventListener('pointercancel', soltar);
      g.addEventListener('focus', () => { if (textoSel !== clave) seleccionarTexto(clave); });
      g.addEventListener('keydown', e => {
        const paso = e.shiftKey ? 5 : 1;
        const d = { ArrowLeft: [-paso, 0], ArrowRight: [paso, 0], ArrowUp: [0, -paso], ArrowDown: [0, paso] }[e.key];
        if (!d) return;
        e.preventDefault();
        T.cx = limitar(T.cx + d[0], LIM_TEXTO.x[0], LIM_TEXTO.x[1]);
        T.cy = limitar(T.cy + d[1], LIM_TEXTO.y[0], LIM_TEXTO.y[1]);
        actualizarTexto(clave);
      });
    }

    /* panel y selector de vista */
    const svgEsp = document.createElementNS(NS_SVG, 'svg');
    svgEsp.setAttribute('viewBox', '0 0 500 500');
    svgEsp.setAttribute('role', 'img');
    svgEsp.setAttribute('aria-label', 'Camiseta Dolphin, vista trasera');
    svgEsp.setAttribute('data-r', 'svg-espalda');
    svgEsp.setAttribute('hidden', '');
    svg.parentNode.appendChild(svgEsp);

    function dibujarEspalda() {
      if (vista !== 'espalda') return;
      try {
        const e = construirEspalda();
        prefijarIds(e, 'esp-');
        svgEsp.replaceChildren(...e.childNodes);
        for (const f of formasE) {
          const el = svgEsp.querySelector(`[data-uid="${f.uid}"]`);
          if (el) { f.el = el; enlazarForma(f, el); }
        }
        for (const c of ['nombre', 'numero']) {
          txt[c].el = null;
          const el = txt[c].texto ? svgEsp.querySelector(`[data-texto="${c}"]`) : null;
          if (el) { txt[c].el = el; enlazarTexto(c, el); }
        }
        dibujarGuia();
        seleccionar(activo, true);
      } catch (err) { /* si algo falla en la espalda, el frente sigue funcionando */ }
    }

    svgEsp.addEventListener('click', alTocarZonaEspalda);

    const tabs = {};
    function mostrarVista(v) {
      vista = v;
      svg.toggleAttribute('hidden', v !== 'frente');
      svgEsp.toggleAttribute('hidden', v === 'frente');
      for (const k in tabs) tabs[k].setAttribute('aria-pressed', String(k === v));
      dibujarEspalda();
      dibujarGuia(); sincronizarFormas(); pintar();
    }

    (function crearVistas() {
      const caja = document.createElement('div');
      caja.className = 'cd-vistas';
      caja.setAttribute('role', 'group');
      caja.setAttribute('aria-label', 'Vista de la camiseta');
      for (const [k, texto] of [['frente', 'Frente'], ['espalda', 'Espalda']]) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-vista-btn'; b.textContent = texto;
        b.addEventListener('click', () => { mostrarVista(k); decir(k === 'frente' ? 'Vista frontal.' : `Espalda ${NOMBRE_ESP[espModo]}.`); });
        tabs[k] = b; caja.appendChild(b);
      }
      if (raiz.dataset.fija === 'true') {
        const bf = document.createElement('button');
        bf.type = 'button'; bf.className = 'cd-fijar'; bf.textContent = 'Soltar camiseta';
        bf.setAttribute('aria-pressed', 'true');
        bf.addEventListener('click', () => {
          const fija = raiz.dataset.fija === 'true';
          raiz.dataset.fija = String(!fija);
          bf.textContent = fija ? 'Fijar camiseta' : 'Soltar camiseta';
          bf.setAttribute('aria-pressed', String(!fija));
        });
        caja.appendChild(bf);
      }
      svg.parentNode.insertBefore(caja, svg);
      tabs.frente.setAttribute('aria-pressed', 'true'); tabs.espalda.setAttribute('aria-pressed', 'false');
    })();

    let pnlEsp = null;
    (function crearPanelEspalda() {
      const det = document.createElement('details');
      det.className = 'cd-bloque';
      det.open = true;
      det.innerHTML = `
        <summary>Espalda</summary>
        <p class="cd-ayuda cd-ayuda-arriba">La espalda parte del frente: elige el fondo. Encima puedes agregar formas propias (con la espalda a la vista, usa el bloque Formas) y poner nombre y número.</p>
        <div class="cd-posiciones" role="group" aria-label="Cómo es la espalda" data-k="modos"></div>
        <div class="cd-esp-color" data-k="color" hidden>
          <p class="cd-ayuda">Color de la espalda</p>
          <div class="cd-fm-paleta" role="group" aria-label="Color de la espalda lisa" data-k="paleta"></div>
        </div>
        <p class="cd-ayuda" data-k="ayuda"></p>
        <div class="cd-esp-texto">
          <p class="cd-ayuda">Nombre y número (opcional). Arrástralos sobre la espalda para ubicarlos.</p>
          <label class="cd-esp-campo">Nombre <input type="text" data-k="nombre" maxlength="14" autocomplete="off" placeholder="Ej: PÉREZ"></label>
          <label class="cd-esp-campo">Número <input type="text" data-k="numero" maxlength="2" inputmode="numeric" autocomplete="off" placeholder="10"></label>
          <div class="cd-tx-editor" data-k="editor-texto" hidden>
            <div class="cd-fm-partes" role="group" aria-label="Elemento que estás editando" data-k="texto-elegir"></div>
            <label class="cd-esp-campo">Tipografía <select data-k="fuente"></select></label>
            <div class="cd-fm-paleta" role="group" aria-label="Color del texto" data-k="paleta-texto"></div>
            <div class="cd-fm-rangos">
              <label class="cd-rango">Tamaño <input type="range" data-k="t-tam" min="40" max="300" step="1"></label>
              <label class="cd-rango">Giro <input type="range" data-k="t-giro" min="-180" max="180" step="1"></label>
              <label class="cd-rango" data-k="t-arco-fila">Arco <input type="range" data-k="t-arco" min="-100" max="100" step="1"></label>
            </div>
            <div class="cd-fm-botones">
              <button class="cd-btn chico" type="button" data-k="t-centrar">Centrar</button>
              <button class="cd-btn chico" type="button" data-k="t-inicio">Posición inicial</button>
            </div>
          </div>
        </div>
        <button class="cd-btn chico" type="button" data-k="copiar">Copiar las formas del frente a la espalda</button>`;
      const k = n => det.querySelector(`[data-k="${n}"]`);
      const AYUDA = {
        igual: 'Fondo: la estampa del delantero se repite en la espalda. Las mangas se ven del otro lado.',
        volteada: 'Fondo: la imagen del frente volteada, como en un espejo.',
        lisa: 'Fondo de un solo color, aunque el frente tenga formas.'
      };
      const botones = {};
      for (const [m, texto] of [['igual', 'Igual al frente'], ['volteada', 'Volteada'], ['lisa', 'Lisa']]) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-btn'; b.textContent = texto; b.dataset.modo = m;
        b.addEventListener('click', () => {
          espModo = m; activar();
          mostrarVista('espalda');
          sincronizarEspalda(); cambio();
          decir(`Espalda ${NOMBRE_ESP[m]}.`);
        });
        botones[m] = b; k('modos').appendChild(b);
      }
      const verEspalda = () => { if (vista !== 'espalda') mostrarVista('espalda'); };
      const limpiarNombre = v => v.toUpperCase().replace(/[^\p{L}\p{N} .'\-]/gu, '').slice(0, 14);
      const limpiarNumero = v => v.replace(/\D/g, '').slice(0, 2);
      const alEscribir = (clave, valor, input) => {
        txt[clave].texto = valor;
        if (input.value !== valor) input.value = valor;
        const otro = clave === 'nombre' ? 'numero' : 'nombre';
        if (valor) { textoSel = clave; formaSelE = null; }
        else if (textoSel === clave) textoSel = txt[otro].texto ? otro : null;
        activar(); verEspalda(); sincronizarFormas(); sincronizarEspalda(); cambio();
      };
      k('nombre').addEventListener('input', e => alEscribir('nombre', limpiarNombre(e.target.value), e.target));
      k('numero').addEventListener('input', e => alEscribir('numero', limpiarNumero(e.target.value), e.target));

      // editor del texto elegido
      for (const [c, nom] of [['nombre', 'Nombre'], ['numero', 'Número']]) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-btn chico'; b.dataset.clave = c; b.textContent = nom;
        b.addEventListener('click', () => { if (txt[c].texto) seleccionarTexto(c); });
        k('texto-elegir').appendChild(b);
      }
      for (const f of FUENTES) {
        const o = document.createElement('option');
        o.value = f.id; o.textContent = f.nombre; o.style.fontFamily = f.familia;
        k('fuente').appendChild(o);
      }
      k('fuente').addEventListener('change', e => { if (!textoSel) return; txt[textoSel].fuente = e.target.value; activar(); actualizarTexto(textoSel, true); sincronizarEspalda(); });
      for (const [campoR, prop] of [['t-tam', 'tam'], ['t-giro', 'giro'], ['t-arco', 'arco']]) {
        k(campoR).addEventListener('input', e => {
          if (!textoSel) return;
          txt[textoSel][prop] = +e.target.value;
          activar(); actualizarTexto(textoSel, prop === 'arco');
        });
      }
      k('t-centrar').addEventListener('click', () => { if (!textoSel) return; txt[textoSel].cx = 250; activar(); actualizarTexto(textoSel); decir('Centrado.'); });
      k('t-inicio').addEventListener('click', () => {
        if (!textoSel) return;
        const c = textoSel, n = nuevoTexto(c);
        Object.assign(txt[c], { cx: n.cx, cy: n.cy, tam: 100, giro: 0, arco: 0 });
        activar(); actualizarTexto(c, true); sincronizarEspalda(); decir('Posición inicial.');
      });
      k('copiar').addEventListener('click', () => {
        if (!formas.length) { decir('El frente no tiene formas para copiar.'); return; }
        formasE.forEach(f => { if (f.el) f.el.remove(); });
        formasE = []; formaSelE = null;
        const cambia = { 'manga-izq': 'manga-der', 'manga-der': 'manga-izq' };
        for (const f of formas) {
          if (formasE.length >= MAX_FORMAS) break;
          const m = !!cambia[f.parte];   // las mangas cambian de lado en la espalda
          formasE.push({ ...f, el: null, uid: ++formaUid, lado: 'espalda', parte: cambia[f.parte] || f.parte, cx: m ? 500 - f.cx : f.cx, giro: m ? -f.giro : f.giro });
        }
        espModo = 'lisa'; espColor = colorEn(250, 230) || null;   // fondo liso para no duplicar las formas del frente
        activar(); mostrarVista('espalda'); sincronizarEspalda(); cambio();
        decir('Formas copiadas a la espalda. Ahora puedes moverlas o quitarlas sin afectar el frente.');
      });
      pnlEsp = { det, k, botones, AYUDA, paletaUsada: null, paletaTextoUsada: null };
      const antes = r('bloque-escudo') || raiz.querySelector('.cd-acciones');
      antes.parentNode.insertBefore(det, antes);
    })();

    function sincronizarEspalda() {
      if (!pnlEsp) return;
      const { k, botones, AYUDA } = pnlEsp;
      for (const m in botones) botones[m].setAttribute('aria-pressed', String(m === espModo));
      k('ayuda').textContent = AYUDA[espModo];
      sincronizarTexto();
      k('color').hidden = espModo !== 'lisa';
      if (espModo !== 'lisa') return;
      const pal = k('paleta');
      if (pnlEsp.paletaUsada !== paleta) {
        pnlEsp.paletaUsada = paleta;
        pal.replaceChildren();
        for (const [hex, nom] of paleta) {
          const b = document.createElement('button');
          b.type = 'button'; b.dataset.color = hex; b.style.background = hex;
          b.setAttribute('aria-label', `Espalda color ${nom}`);
          b.addEventListener('click', () => { espColor = hex; activar(); sincronizarEspalda(); cambio(); });
          pal.appendChild(b);
        }
        const libre = document.createElement('input');
        libre.type = 'color'; libre.setAttribute('aria-label', 'Color personalizado de la espalda');
        libre.addEventListener('input', () => { espColor = libre.value.toLowerCase(); activar(); sincronizarEspalda(); cambio(); });
        pal.appendChild(libre);
      }
      const actual = colorEspalda();
      pal.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === actual)));
      const libre = pal.querySelector('input[type=color]');
      if (libre) libre.value = actual;
    }
    function sincronizarTexto() {
      const { k } = pnlEsp;
      if (k('nombre').value !== txt.nombre.texto) k('nombre').value = txt.nombre.texto;
      if (k('numero').value !== txt.numero.texto) k('numero').value = txt.numero.texto;
      if (textoSel && !txt[textoSel].texto) textoSel = null;
      const hay = !!(txt.nombre.texto || txt.numero.texto);
      const sel = textoSel;
      k('editor-texto').hidden = !hay;
      k('texto-elegir').querySelectorAll('button').forEach(b => { b.hidden = !txt[b.dataset.clave].texto; b.setAttribute('aria-pressed', String(b.dataset.clave === sel)); });
      const controles = [k('fuente').closest('label'), k('paleta-texto'), k('t-tam').closest('.cd-fm-rangos'), k('t-centrar').parentNode];
      controles.forEach(c => { c.hidden = !sel; });
      if (!hay || !sel) return;
      const T = txt[sel];
      k('t-arco-fila').hidden = sel !== 'nombre';
      k('fuente').value = fuenteDe(T.fuente).id;
      k('t-tam').value = Math.round(T.tam);
      k('t-giro').value = Math.round(T.giro);
      k('t-arco').value = Math.round(T.arco);
      const pal = k('paleta-texto');
      if (pnlEsp.paletaTextoUsada !== paleta) {
        pnlEsp.paletaTextoUsada = paleta;
        pal.replaceChildren();
        const ponerColor = hex => { if (!textoSel) return; txt[textoSel].color = hex; activar(); actualizarTexto(textoSel); sincronizarEspalda(); };
        const auto = document.createElement('button');
        auto.type = 'button'; auto.className = 'cd-btn chico'; auto.dataset.auto = '1'; auto.textContent = 'Automático';
        auto.addEventListener('click', () => ponerColor(null));
        pal.appendChild(auto);
        for (const [hex, nom] of paleta) {
          const b = document.createElement('button');
          b.type = 'button'; b.dataset.color = hex; b.style.background = hex;
          b.setAttribute('aria-label', `Texto color ${nom}`);
          b.addEventListener('click', () => ponerColor(hex));
          pal.appendChild(b);
        }
        const libre = document.createElement('input');
        libre.type = 'color'; libre.setAttribute('aria-label', 'Color personalizado del texto');
        libre.addEventListener('input', () => ponerColor(libre.value.toLowerCase()));
        pal.appendChild(libre);
      }
      pal.querySelector('[data-auto]').setAttribute('aria-pressed', String(!T.color));
      pal.querySelectorAll('button[data-color]').forEach(b => b.setAttribute('aria-pressed', String(!!T.color && b.dataset.color === T.color)));
      const libre = pal.querySelector('input[type=color]');
      if (libre) libre.value = colorTextoEfectivo(sel);
    }
    sincronizarEspalda();

    function reiniciarEspalda() {
      espModo = 'igual'; espColor = null; coloresE = {}; reiniciarTextos();
      mostrarVista('frente');
      sincronizarEspalda();
    }


    /* ---------- selector de posición del logo Dolphin ---------- */
    (function crearSelectorMarca() {
      const det = document.createElement('details');
      det.className = 'cd-bloque';
      det.open = true;
      det.innerHTML = '<summary>Logo Dolphin</summary><div class="cd-posiciones" role="group" aria-label="Posición del logo Dolphin en el pecho"></div><p class="cd-ayuda">El logo Dolphin va siempre en la camiseta. Elige en qué lado del pecho.</p>';
      const caja = det.querySelector('.cd-posiciones');
      const botones = {};
      for (const [pos, texto] of [['izq', 'Izquierda'], ['cen', 'Centro'], ['der', 'Derecha']]) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cd-btn'; b.textContent = texto; b.dataset.pos = pos;
        b.addEventListener('click', () => {
          if (pos === marcaPos) return;
          marcaPos = pos;
          dibujarMarca();
          if (escudoOn && escudo.hay() && !escudo.movido()) escudo.centrar();
          marcar();
          activar(); cambio();
          decir(`Logo Dolphin a la ${NOMBRE_POS[pos]}.`);
        });
        botones[pos] = b; caja.appendChild(b);
      }
      function marcar() { for (const k in botones) botones[k].setAttribute('aria-pressed', String(k === marcaPos)); }
      marcar();
      const antes = r('bloque-escudo') || raiz.querySelector('.cd-acciones');
      antes.parentNode.insertBefore(det, antes);
    })();

    /* ---------- arranque ---------- */
    construirModelos();
    cargarDiseno(MODELOS[0].id);
    actualizarCampos();

    // API por si otra parte del tema necesita leer el diseño
    host.api = {
      obtener: () => ({ modelo: modelo.id, colores: { ...colores }, formas: formas.length, personalizado }),
      cambiar: id => { cargarDiseno(id); activar(); cambio(); },
      aplicar: obj => ponerTodo(obj)
    };
  }

  customElements.define('dolphin-configurador', DolphinConfigurador);
})();
